<app-header [filled]="true"></app-header>
<ion-content [lang]="languageService.lang()" scroll-events="true" fullscreen="true"
             [dir]="languageService.dir()">

  <app-column-content
    [title]="pageContent()?.[languageService.lang()].section1Title"
    [content]="pageContent()?.[languageService.lang()].section1Description"></app-column-content>

  <section class="inner-banner" [style]="'background-image: url(' + pageImages()?.bannerImg +')'">
<!--    <div class="banner-overlay"></div>-->
  </section>

  <div class="content-wrapper">
    <app-service-content
      number="01"
      [title]="pageContent()?.[languageService.lang()].investmentTitle"
      [content]="pageContent()?.[languageService.lang()].investmentDescription"
      [imgPath]="pageImages()?.investmentImg"></app-service-content>
  </div>

  @if (!isContentLoading()) {
    <app-content-swiper-slider [sliderId]="'slider1'"
                               [items]="pageContent()?.investmentSlider"></app-content-swiper-slider>
  }

  <section>
    <div class="content-wrapper">
      <app-service-content
        number="02"
        direction="reverse"
        [title]="pageContent()?.[languageService.lang()].assetManagementTitle"
        [content]="pageContent()?.[languageService.lang()].assetManagementDescription"
        [imgPath]="pageImages()?.assetImg"></app-service-content>
    </div>
    @if (!isContentLoading()) {
      <app-content-swiper-slider [sliderId]="'slider2'"
                                 [items]="pageContent()?.assetManagementSlider" bgColor="white"></app-content-swiper-slider>
    }
  </section>

  <div class="faq-wrapper content-wrapper">
    <ion-row>
      <ion-col size="12" size-lg="5">
        <h2 class="h2">{{ 'services.faq.title' | translate }}</h2>
        <p>{{ 'services.faq.description' | translate }}</p>
        <ion-button fill="outline" [routerLink]="['/contact']">{{ 'services.faq.contact_button' | translate }}</ion-button>
      </ion-col>
      <div class="ion-padding ion-hide-sm-down"></div>
      <ion-col>

        <app-faq></app-faq>
      </ion-col>
    </ion-row>
  </div>

  <app-b2b-section></app-b2b-section>
<!--  <article class="article">-->

<!--    <div class="icon-text-list">-->
<!--      <h2>{{  ourServicesPage?.satelGuarantee.title }}</h2>-->
<!--      <ion-row>-->
<!--        @for (x of ourServicesPage?.satelGuarantee.list; track x) {-->
<!--          <ion-col size-lg="4" size="12">-->
<!--            <ion-card mode="md" class="item">-->
<!--              <ion-icon [name]="x.icon + '-outline'"></ion-icon>-->
<!--              <ion-label>-->
<!--                <h4>{{x.title}}</h4>-->
<!--                <p>{{x.text}}</p>-->
<!--              </ion-label>-->
<!--            </ion-card>-->
<!--          </ion-col>-->
<!--        }-->
<!--      </ion-row>-->
<!--    </div>-->

<!--    <div class="inner-other-links">-->
<!--      <ion-row>-->
<!--        <ion-col>-->
<!--          <a [routerLink]="['/leasing-and-rental']" class="leasing">-->
<!--            <span class="overlay">{{ leasingPage?.pageTitle }}</span>-->
<!--          </a>-->
<!--        </ion-col>-->
<!--        <ion-col>-->
<!--          <a [routerLink]="['/asset-and-property']" class="assets">-->
<!--            <span class="overlay">{{ assetPage?.pageTitle }}</span>-->
<!--          </a>-->
<!--        </ion-col>-->
<!--      </ion-row>-->
<!--    </div>-->
<!--  </article>-->

  <app-footer></app-footer>
</ion-content>
